import React from 'react'
import UploaderWrapper from './components/UploaderWrapper'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Certificate from './components/Certificate'

function App() {
  return (
    <div className="w-full h-screen bg-primary flex justify-center items-center">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UploaderWrapper />} />
          <Route path="certificate/:id" element={<Certificate />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
